import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./PriceBreakupModal.css";

function PriceBreakupModal({ show, handleClose }) {
  return (
    <Modal
    show={show}
    onHide={handleClose}
    centered
    dialogClassName="PriceBreakupModal"
>
      <Modal.Body className="price-breakup-body">

        <h3 className="price-plan-title">6 Month Plan</h3>
        <p className="price-plan-subtitle">
          based on your experience
        </p>

        <hr />

        <div className="price-row">
          <span>Total MRP</span>
          <span>₹5,498</span>
        </div>

        <div className="price-row">
          <span>Discount</span>
          <span className="green-text">-₹899</span>
        </div>

        <div className="price-row">
          <span>Coupon Discount</span>
          <span className="green-text">-₹0</span>
        </div>

        <div className="price-row">
          <span>
            Taxes & Fees{" "}
            <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
          </span>
          <span>₹828</span>
        </div>

        <div className="dashed-divider"></div>

        <div className="price-total">
          <span>Total Price</span>
          <span>₹5,427</span>
        </div>

        <div className="dashed-divider"></div>

        <div className="text-center mt-2">
          <button
            className="got-it-btn"
            onClick={handleClose}
          >
            Got it!
          </button>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default PriceBreakupModal;